import { type TextProps } from "../model";
import React, { CSSProperties, useMemo } from "react";
import "./styles.scss";
import { type KC_Weights } from "../../ds_commons";
import TwemojiWrapper from "../../../components/TwemojiWrapper/TwemojiWrapper";

interface KC_UITextProps extends TextProps {
  weight: KC_Weights | "bold" | "md" | "reg";
  block?: boolean;
  size?: "standard" | "medium";
  fontStyle?: "normal" | "italic";
  underline?: boolean;
  onClick?: () => void;
  twemoji?: boolean;
  isGray?: boolean;
  lineThrough?: boolean;
}

export default function KC_UIText(props: KC_UITextProps) {
  const style = useMemo<CSSProperties>(() => {
    return {
      display: props.block ? "block" : undefined,
      fontStyle: props.fontStyle,
      textDecoration: props.lineThrough ? "line-through" : ""
    };
  }, [props]);

  const className = useMemo(() => {
    if (props.size === "medium") {
      return "kc-ui-text-medium";
    }
    return "";
  }, [props]);

  return (
    <span
      id={props.id}
      className={`kc-ui-text ui-text-${props.weight} ${
        props.className ?? ""
      } ${className} ${props.underline ? "underline" : ""} ${props.isGray ? "kc-ui-text-gray" : ""}`}
      style={style}
      onClick={props.onClick}
    >
      {!props.twemoji && props.text}
      {!!props.twemoji && (
        <TwemojiWrapper isText={true}>{props.text}</TwemojiWrapper>
      )}
    </span>
  );
}
